"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$layoutToggle;

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCREEN_BREAKPOINT = 768;
var LayoutFeatures;

(function (LayoutFeatures) {
  LayoutFeatures["row"] = "row";
  LayoutFeatures["column"] = "column";
  LayoutFeatures["reverse"] = "reverse";
  LayoutFeatures["first"] = "first";
  LayoutFeatures["last"] = "last";
})(LayoutFeatures = exports.LayoutFeatures || (exports.LayoutFeatures = {}));

var Layout;

(function (Layout) {
  Layout["row"] = "row";
  Layout["rowReverse"] = "row reverse";
  Layout["column"] = "column";
  Layout["columnReverse"] = "column reverse";
  Layout["top"] = "column first";
  Layout["topReverse"] = "column first reverse";
  Layout["left"] = "row first";
  Layout["right"] = "row last"; // leftReverse = 'row first reverse',
  // bottom = 'column last',
  // bottomReverse = 'column last reverse',
})(Layout = exports.Layout || (exports.Layout = {}));

exports.layoutToggleMap = (_exports$layoutToggle = {}, _defineProperty(_exports$layoutToggle, Layout.columnReverse, Layout.row), _defineProperty(_exports$layoutToggle, Layout.row, Layout.columnReverse), _exports$layoutToggle);
exports.default_layout = Layout.row;

function layoutByWindowWidth() {
  if (typeof window === 'undefined') return undefined;
  var viewWidth = window.innerWidth;

  if (viewWidth < SCREEN_BREAKPOINT) {
    return Layout.columnReverse;
  }

  return undefined;
}

exports.layoutByWindowWidth = layoutByWindowWidth;